import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import styles from '../../styles/style.module.scss';
import metabolism from '../../../../assets/images/cardPlanMetabolism.png';
import dna from '../../../../assets/images/dna.png';
import metabolismAnalysis from '../../../../assets/images/metabolism-analysis.png';
import map from '../../../../assets/images/map.png';
import girl from '../../../../assets/images/girlWithPhone.png';
import ethnicityBH from '../../../../assets/images/ethnicityBahrain.png';
import ethnicityBE from '../../../../assets/images/ethnicityBelgium.png';
import ethnicityDK from '../../../../assets/images/ethnicityDenmark.png';
import ethnicityFI from '../../../../assets/images/ethnicityFinland.png';
import ethnicityFR from '../../../../assets/images/ethnicityFrance.png';
import ethnicityDE from '../../../../assets/images/ethnicityGermany.png';
import ethnicityIL from '../../../../assets/images/ethnicityIsrael.png';
import ethnicityKW from '../../../../assets/images/ethnicityKuwait.png';
import ethnicityNO from '../../../../assets/images/ethnicityNorway.png';
import ethnicityPT from '../../../../assets/images/ethnicityPortugal.png';
import ethnicityQA from '../../../../assets/images/ethnicityQatar.png';
import ethnicitySA from '../../../../assets/images/ethnicitySaudiArabia.png';

import ethnicitySE from '../../../../assets/images/ethnicitySweden.png';
import ethnicityCH from '../../../../assets/images/ethnicitySwitzerland.png';
import ethnicityAE from '../../../../assets/images/ethnicityUAE.png';
import ethnicityUS from '../../../../assets/images/ethnicityUS.png';


import { ReactComponent as PeopleIcon } from '../../../../assets/images/peopleIcon.svg';
import { ReactComponent as ReviewIcon } from '../../../../assets/images/reviewIcon.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/images/arrowGreenRight.svg';

import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { useStore } from 'src/onboarding/store/store';
import { FaceHighlight } from 'src/onboarding/components/FaceHighlight/FaceHighlight';
import getLocale from 'src/localization/get-locale';
import { getUserCountry } from 'src/onboarding/helpers/getUserCountry';

const imageMap = {
  metabolism: metabolism,
  dna: dna,
  'metabolism-analysis': metabolismAnalysis,
};

const ethnicityMap: Record<string, string> = {
  bh: ethnicityBH,
  be: ethnicityBE,
  dk: ethnicityDK,
  fi: ethnicityFI,
  fr: ethnicityFR,
  de: ethnicityDE,
  il: ethnicityIL,
  kw: ethnicityKW,
  no: ethnicityNO,
  pt: ethnicityPT,
  qa: ethnicityQA,
  sa: ethnicitySA,
  se: ethnicitySE,
  ch: ethnicityCH,
  ae: ethnicityAE,
  US: ethnicityUS,
  DEFAULT: map,
};

export const StatsComponent = () => {
  const { stats } = useRemoteConfig();
  const imageUrl = useStore((state) => state.imageUrl);
  const photoError = useStore((state) => state.photoError);
  const faceData = useStore((state) => state.faceData);
  const locale = getLocale();

  const userCountry = getUserCountry();

  const ethnicityImage = ethnicityMap[userCountry] || ethnicityMap.DEFAULT;

  const renderHighlightedTitle = (titleText: string) => {
    if (!titleText) return null;

    const parts = titleText.split(/\*\*(.*?)\*\*/);

    return parts.map((part, index) =>
      index % 2 === 1 ? (
        <span key={index} style={{ fontFamily: 'Inter', fontSize: '15px', fontWeight: 600 }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <>
      {stats.image === 'face-scan' ? (
        <div className={styles.userImageContainer}>
          <img src={photoError || !imageUrl ? girl : imageUrl} alt='photo of user' />

          <img src={map} alt='map and dna stats' />
          {/* <ArrowIcon /> */}
        </div>
      ) : stats.image === 'face-scan-magic' ? (
        <FaceHighlight imageUrl={photoError || !imageUrl ? girl : imageUrl} faceData={faceData} />
      ) : stats.image === 'ethnicity' ? (
        <div className={styles.userImageContainer}>
          <img src={photoError || !imageUrl ? girl : imageUrl} alt='photo of user' />

          {/* maps images of countries */}
          <img src={ethnicityImage} alt='map or ethnicity image' />
        </div>
      ) : (
        <div
          className={styles.image}
          style={{ backgroundImage: `url(${imageMap[stats.image]})` }}
        />
      )}
      <div className={styles.stats}>
        <div className={styles.statsItem}>
          <PeopleIcon />
          <Caption size='l' className={styles.statsDesc}>
            {renderHighlightedTitle(stats.firstOption[locale])}
          </Caption>
        </div>
        <div className={styles.statsItem}>
          <ReviewIcon />
          <Caption size='l' className={styles.statsDesc}>
            {renderHighlightedTitle(stats.secondOption[locale])}
          </Caption>
        </div>
      </div>
    </>
  );
};
